/* tslint:disable */
/* eslint-disable */
/**
 * Hyper-Timesheet.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PersonaleRapportinoCreateDTO } from './PersonaleRapportinoCreateDTO';
import {
    PersonaleRapportinoCreateDTOFromJSON,
    PersonaleRapportinoCreateDTOFromJSONTyped,
    PersonaleRapportinoCreateDTOToJSON,
    PersonaleRapportinoCreateDTOToJSONTyped,
} from './PersonaleRapportinoCreateDTO';

/**
 * 
 * @export
 * @interface RapportiniCreateDTO
 */
export interface RapportiniCreateDTO {
    /**
     * 
     * @type {number}
     * @memberof RapportiniCreateDTO
     */
    idCommessa?: number | null;
    /**
     * 
     * @type {number}
     * @memberof RapportiniCreateDTO
     */
    idCliente?: number;
    /**
     * 
     * @type {string}
     * @memberof RapportiniCreateDTO
     */
    tipoRapportino?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof RapportiniCreateDTO
     */
    dataRapportino?: Date;
    /**
     * 
     * @type {string}
     * @memberof RapportiniCreateDTO
     */
    descrizioneAttivita?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RapportiniCreateDTO
     */
    ubicazioneTest?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RapportiniCreateDTO
     */
    descrizioneLavori?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RapportiniCreateDTO
     */
    strumentiMisura?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof RapportiniCreateDTO
     */
    isRelazioneProva?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RapportiniCreateDTO
     */
    isSchedaTecnica?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RapportiniCreateDTO
     */
    riferimentoOrdine?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RapportiniCreateDTO
     */
    luogo?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RapportiniCreateDTO
     */
    personaRiferimento?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof RapportiniCreateDTO
     */
    isTrimestrale?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RapportiniCreateDTO
     */
    isSemestrale?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RapportiniCreateDTO
     */
    isAnnuale?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RapportiniCreateDTO
     */
    isManutenzioneStraordinaria?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RapportiniCreateDTO
     */
    isControlliNonDistruttivi?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof RapportiniCreateDTO
     */
    dataRiferimentoOrdine?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof RapportiniCreateDTO
     */
    riferimentoDDT?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof RapportiniCreateDTO
     */
    dataRiferimentoDDT?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof RapportiniCreateDTO
     */
    attrezzatureSpeciali?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof RapportiniCreateDTO
     */
    isCheckList?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RapportiniCreateDTO
     */
    isReportAnomalie?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RapportiniCreateDTO
     */
    isReportIntervento?: boolean;
    /**
     * 
     * @type {Array<PersonaleRapportinoCreateDTO>}
     * @memberof RapportiniCreateDTO
     */
    personaleRapportino?: Array<PersonaleRapportinoCreateDTO> | null;
}

/**
 * Check if a given object implements the RapportiniCreateDTO interface.
 */
export function instanceOfRapportiniCreateDTO(value: object): value is RapportiniCreateDTO {
    return true;
}

export function RapportiniCreateDTOFromJSON(json: any): RapportiniCreateDTO {
    return RapportiniCreateDTOFromJSONTyped(json, false);
}

export function RapportiniCreateDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): RapportiniCreateDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'idCommessa': json['idCommessa'] == null ? undefined : json['idCommessa'],
        'idCliente': json['idCliente'] == null ? undefined : json['idCliente'],
        'tipoRapportino': json['tipoRapportino'] == null ? undefined : json['tipoRapportino'],
        'dataRapportino': json['dataRapportino'] == null ? undefined : (new Date(json['dataRapportino'])),
        'descrizioneAttivita': json['descrizioneAttivita'] == null ? undefined : json['descrizioneAttivita'],
        'ubicazioneTest': json['ubicazioneTest'] == null ? undefined : json['ubicazioneTest'],
        'descrizioneLavori': json['descrizioneLavori'] == null ? undefined : json['descrizioneLavori'],
        'strumentiMisura': json['strumentiMisura'] == null ? undefined : json['strumentiMisura'],
        'isRelazioneProva': json['isRelazioneProva'] == null ? undefined : json['isRelazioneProva'],
        'isSchedaTecnica': json['isSchedaTecnica'] == null ? undefined : json['isSchedaTecnica'],
        'riferimentoOrdine': json['riferimentoOrdine'] == null ? undefined : json['riferimentoOrdine'],
        'luogo': json['luogo'] == null ? undefined : json['luogo'],
        'personaRiferimento': json['personaRiferimento'] == null ? undefined : json['personaRiferimento'],
        'isTrimestrale': json['isTrimestrale'] == null ? undefined : json['isTrimestrale'],
        'isSemestrale': json['isSemestrale'] == null ? undefined : json['isSemestrale'],
        'isAnnuale': json['isAnnuale'] == null ? undefined : json['isAnnuale'],
        'isManutenzioneStraordinaria': json['isManutenzioneStraordinaria'] == null ? undefined : json['isManutenzioneStraordinaria'],
        'isControlliNonDistruttivi': json['isControlliNonDistruttivi'] == null ? undefined : json['isControlliNonDistruttivi'],
        'dataRiferimentoOrdine': json['dataRiferimentoOrdine'] == null ? undefined : (new Date(json['dataRiferimentoOrdine'])),
        'riferimentoDDT': json['riferimentoDDT'] == null ? undefined : json['riferimentoDDT'],
        'dataRiferimentoDDT': json['dataRiferimentoDDT'] == null ? undefined : (new Date(json['dataRiferimentoDDT'])),
        'attrezzatureSpeciali': json['attrezzatureSpeciali'] == null ? undefined : json['attrezzatureSpeciali'],
        'isCheckList': json['isCheckList'] == null ? undefined : json['isCheckList'],
        'isReportAnomalie': json['isReportAnomalie'] == null ? undefined : json['isReportAnomalie'],
        'isReportIntervento': json['isReportIntervento'] == null ? undefined : json['isReportIntervento'],
        'personaleRapportino': json['personaleRapportino'] == null ? undefined : ((json['personaleRapportino'] as Array<any>).map(PersonaleRapportinoCreateDTOFromJSON)),
    };
}

export function RapportiniCreateDTOToJSON(json: any): RapportiniCreateDTO {
    return RapportiniCreateDTOToJSONTyped(json, false);
}

export function RapportiniCreateDTOToJSONTyped(value?: RapportiniCreateDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'idCommessa': value['idCommessa'],
        'idCliente': value['idCliente'],
        'tipoRapportino': value['tipoRapportino'],
        'dataRapportino': value['dataRapportino'] == null ? undefined : ((value['dataRapportino']).toISOString()),
        'descrizioneAttivita': value['descrizioneAttivita'],
        'ubicazioneTest': value['ubicazioneTest'],
        'descrizioneLavori': value['descrizioneLavori'],
        'strumentiMisura': value['strumentiMisura'],
        'isRelazioneProva': value['isRelazioneProva'],
        'isSchedaTecnica': value['isSchedaTecnica'],
        'riferimentoOrdine': value['riferimentoOrdine'],
        'luogo': value['luogo'],
        'personaRiferimento': value['personaRiferimento'],
        'isTrimestrale': value['isTrimestrale'],
        'isSemestrale': value['isSemestrale'],
        'isAnnuale': value['isAnnuale'],
        'isManutenzioneStraordinaria': value['isManutenzioneStraordinaria'],
        'isControlliNonDistruttivi': value['isControlliNonDistruttivi'],
        'dataRiferimentoOrdine': value['dataRiferimentoOrdine'] == null ? undefined : ((value['dataRiferimentoOrdine'] as any).toISOString()),
        'riferimentoDDT': value['riferimentoDDT'],
        'dataRiferimentoDDT': value['dataRiferimentoDDT'] == null ? undefined : ((value['dataRiferimentoDDT'] as any).toISOString()),
        'attrezzatureSpeciali': value['attrezzatureSpeciali'],
        'isCheckList': value['isCheckList'],
        'isReportAnomalie': value['isReportAnomalie'],
        'isReportIntervento': value['isReportIntervento'],
        'personaleRapportino': value['personaleRapportino'] == null ? undefined : ((value['personaleRapportino'] as Array<any>).map(PersonaleRapportinoCreateDTOToJSON)),
    };
}

